export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ TERMS VALIDATION:\n');
      coloredDebug(true);
      console.groupEnd();
    }

    return true;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ TERMS VALIDATION:\n');
      console.error(err);
      coloredDebug(false);
      console.groupEnd();
    }

    return false;
  }
}
